import React, { Component } from 'react';
import './FamilyMemberList.css';
import { constants } from '../../Constants';

class FamilyMember extends Component {
    render() {
        const { member, deleteFamilyMember, index } = this.props;

        return (
            <tr key={index}>
                <td>
                    <span className="sh-gnrl-cchc-main-title">
                        {member.user.full_name}
                    </span>
                </td>
                <td>
                    <span className="sh-gnrl-cchc-main-title">
                        {member.patient_relation.name}
                    </span>
                </td>
                <td>
                    <span className="sh-gnrl-cchc-main-title">
                        {member.user.email_address}
                    </span>
                </td>
                <td>
                    <div className="sh-gnrl-col-1 sh-mble-col-unset sh-member-col">
                        <div className="sh-gnrl-btn-container">
                            <button
                                className="sh-btn-cancel sh-gnrl-btn-session"
                                onClick={() =>deleteFamilyMember(member)}
                            >
                                <span className="sh-text-icon">
                                    {constants.DELETE_TXT}
                                </span>
                                <span className="icon"></span>
                            </button>
                        </div>
                    </div>
                </td>
            </tr>
        );
    }
}

export default FamilyMember;



// WEBPACK FOOTER //
// ./src/components/FamilyMemberList/index.js